module.exports = __webpack_public_path__ + "img/routing.5199989d.svg";